import * as React from 'react';
import styled from 'styled-components';
import * as T from '../../Tooltip/Simple';
import { AnimationBlock } from '../../Helpers';

import { Base, ctxModalClass } from '..';
import { makeSlot, Entry, Layout,} from '../slots';
import { useKeyboard } from '../plugins';

import HeaderS from '../Header';
import BodyS from '../Body';
import FooterS from '../Footer';
import TitleS from '../Title';
import CloseS from '../Close';
import CancelS from '../Cancel';
import AcceptS, { acceptTooltiped } from '../Accept';



export interface IModalProps {
    /**
     * Указывает, показываться модалке или нет
     */
    isShow: boolean,

    /**
     * Обработчик, который поможет закрыться модалке
     */
    handleClose: () => void,

    /**
     * Обработчик, который вызовется при нажатии на условную кнопку "принять"
     */
    handleAccept: () => void,

    className?: string,
}

// export const ModalAnimation = styled(Animation)`
//     transition: all .33s ease-in-out;
//     position: fixed;
//     top: 0;
//     left: 0;
//     right: 0;
//     bottom: 0;
//     margin: 0 !important;
//     background-color: rgba(95, 95, 95, 0.5);
// `;

export const Container = styled.div`
    background-color: #fff;
    position: fixed;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    box-shadow: 0px 13px 34px rgba(0, 0, 0, 0.4);
    width: 500px;
    overflow: hidden;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    color: initial;
`;



export const cssClasses = {
    MAIN: ctxModalClass(),
    CONTAINER: ctxModalClass('container'),
    HEADER: ctxModalClass('header'),
    BODY: ctxModalClass('body'),
    ACTIONS: ctxModalClass('actions'),
    ACCEPT_BTN: ctxModalClass('accept-btn'),
    CLOSE_BTN: ctxModalClass('close-btn'),
}




export const Modal: React.FunctionComponent<IModalProps> = ({ 
    children, 
    isShow, 
    handleClose, 
    handleAccept,
    className,
}) => {
    

    const accept = () => {
        handleClose();
        handleAccept();
    }

    useKeyboard({ 
        showed: isShow,
        handleClose, 
        handleAccept,
    });

    return (
        <Base
            showed={isShow}>
            <MAnimation isShow={isShow}>
                <Entry connectLayout={children}>
                    <Container className={className}>
                        <Layout name="header" handleClose={handleClose} />
                        <Layout name="body" />
                        <Layout 
                            name="footer"
                            accept={accept}
                            handleClose={handleClose}
                        />
                    </Container>
                </Entry>
            </MAnimation>
        </Base>
    );
}

const MAnimation = styled(AnimationBlock)`
    background-color: rgba(95, 95, 95, .5);
`;

export const Header = makeSlot('header')(HeaderS)

export const Title = makeSlot('title')(TitleS);

export const Body = makeSlot('body')(BodyS);

export const Accept = makeSlot('accept')(AcceptS);

export const Cancel = makeSlot('cancel')(CancelS);

export const Close = makeSlot('close')(CloseS);

export const Footer = makeSlot('footer')(FooterS);

export const AcceptTooltiped = acceptTooltiped(({ text }) => {

    const { isShowed, handlers } = T.useControl();

    return (
        <T.Tooltip
            show={isShowed}
            dir="top">
            <T.Target {...handlers}>
                <Layout name="accept" />
            </T.Target>
            <T.Text>{text}</T.Text>
        </T.Tooltip>
    );
});
